













































import { Component, Mixins, Prop } from 'vue-property-decorator';
import VueSlider from 'vue-slider-component';
import Control from './Control';

export enum Option {
    Number,
    Range,
}

type Value = number | [number, number];

@Component({
    components: {VueSlider},
    watch: {
        numberValueRaw: 'updateValue',
        minRaw: 'updateValue',
        maxRaw: 'updateValue',
    },
})
export default class NumberOrRangeControl extends Mixins<Control<Value>>(Control) {
    @Prop({type: Array, required: true})
    public readonly bounds: [number, number];

    get min(): number|null {
        return this.getInt(this.minRaw);
    }

    get max(): number|null {
        return this.getInt(this.maxRaw);
    }

    get numberValue(): number|null {
        return this.getInt(this.numberValueRaw);
    }
    /** Make enum part of class */
    public Option = Option;

    private input: Option = Option.Number;
    private numberValueRaw: string = '';
    private minRaw: string = '';
    private maxRaw: string = '';

    public mounted(): void {
        if (Array.isArray(this.value)) {
            this.minRaw = '' + this.value[0];
            this.maxRaw = '' + this.value[1];
            this.input = Option.Range;
            return;
        }

        if (this.value !== null) {
            this.numberValueRaw = '' + this.value;
            this.input = Option.Number;
            return;
        }

        this.input = Option.Number;
    }

    protected updateRangeSlider(value: [string, string]): void {
        this.minRaw = value[0];
        this.maxRaw = value[1];
    }

    protected getValue(): Value | null {
        if (this.input === Option.Number) {
            return this.numberValue;
        }

        if (this.input === Option.Range && this.min !== null && this.max !== null) {
            return [this.min, this.max];
        }

        return null;
    }

    protected validateCurrentValue(): boolean {
        const value = this.getValue();

        if (value === null) {
            return false;
        }

        return this.isValueInBounds();
    }

    protected normalize(value: number): number {
        return Math.max(this.bounds[0], Math.min(this.bounds[1], value));
    }

    protected isValueInBounds(): boolean {
        const value = this.getValue();

        if (value === null) {
            return false;
        }

        return Array.isArray(value)
            ? this.isInBounds(value[0]) && this.isInBounds(value[1])
            : this.isInBounds(value);
    }

    private getInt(value: string): number | null {
        const converted = Number.parseInt(value, 10);

        return isNaN(converted) ? null : converted;
    }

    private isInBounds(value: number): boolean {
        return value >= this.bounds[0] && value <= this.bounds[1];
    }
}
